export const STATUSES = {
  saved: {
    index: 10,
    value: "saved",
    label: "Choose an option",
    previous: "saved"
  },
  messaged: {
    index: 20,
    value: "messaged",
    label: "Contacted",
    previous: "saved"
  },
  toured: {
    index: 30,
    value: "toured",
    label: "Toured",
    previous: "messaged"
  },
  applied: {
    index: 40,
    value: "applied",
    label: "Applied",
    previous: "toured"
  }
};
